export const transformBoolean = (currentValue, originalValue) => !!originalValue
